import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import IconChevronDown from '../../assets/svgs/chevron-down.svg';
import IconChevronUp from '../../assets/svgs/chevron-up.svg';

const Container = styled.div`
  display: block;
  font-weight: normal;
  font-family: ${p => p.theme.fonts.primary};
  font-size: ${remCalc(14)};
  line-height: 1.5;
  letter-spacing: ${remCalc(0.25)};
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  color: ${p => p.theme.colours.grey_900};
  cursor: pointer;
`;

const Arrow = styled.span`
  margin-left: ${p => p.theme.spacing(1)};
`;

const Content = styled.div`
  margin-top: ${p => p.theme.spacing(1)};
`;

const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-position: inside;
`;

const ListItem = styled.li`
  list-style-type: disc;
`;

const Grey600Text = styled.span`
  color: ${p => p.theme.colours.grey_600};
`;

const Grey900Text = styled.span`
  color: ${p => p.theme.colours.grey_900};
`;

const FreeGiftAccordion = props => {
  const { title, items, description } = props;
  const [contentOpen, toggleContentOpen] = useState(
    title === 'Shipping Method'
  );
  const renderOutOfStock = <Grey600Text>(Out of stock)</Grey600Text>;

  const renderDescription =
    title === 'Shipping Method' ? (
      <Grey900Text>{description}</Grey900Text>
    ) : (
      <Grey600Text>{description}</Grey600Text>
    );

  return (
    <Container>
      <Title onClick={() => toggleContentOpen(!contentOpen)}>
        {title}
        <Arrow>
          {contentOpen ? (
            <IconChevronUp width={8} height={8} />
          ) : (
            <IconChevronDown width={8} height={8} />
          )}
        </Arrow>
      </Title>
      {contentOpen && (
        <Content data-testid="content">
          {items && (
            <UnorderedList>
              {items.map((item, key) => {
                return (
                  <ListItem key={key}>
                    {!item.available && renderOutOfStock} {item.text}
                  </ListItem>
                );
              })}
            </UnorderedList>
          )}
          {renderDescription}
        </Content>
      )}
    </Container>
  );
};

FreeGiftAccordion.propTypes = {
  /** Sets the description text */
  description: PropTypes.string,
  /** Sets the list of items */
  items: PropTypes.array,
  /** Sets the title */
  title: PropTypes.string
};

export default FreeGiftAccordion;
